import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <h2 className="text-xl font-semibold mb-2">Page Not Found</h2>
        <p className="text-gray-500 mb-6">The page you're looking for doesn't exist.</p>
        <Link
          to="/"
          className="inline-flex items-center px-4 py-2 bg-[#cc0404] text-white rounded-[4px] hover:bg-[#a30303] text-sm"
        >
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
